export default __webpack_public_path__ + "082ea206bc898fca80b1310d6a11dcf0.png";